import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Spin from '@components/Spin'

const Redirector = props => {
  const { message, type, url, wait } = props

  const timeoutRef = useRef(null)

  // redirects to the resource editor if the url prop has been set
  // optionally adds a delay before redirecting so message/spinner can be shown
  useEffect(() => {
    if (url) {
      // redirect with delay
      if (wait > 0 && !timeoutRef.current) {
        timeoutRef.current = setTimeout(() => {
          redirectTo(url)
        }, wait)
      } else {
        // redirect directly
        redirectTo(url)
      }
    }
  }, [url])

  const redirectTo = url => {
    // Note: Just setting window.location will cause Capybara to fail to redirect consistently in headless mode
    window.location.href = url
  }

  const hasUrl = url && url.length > 0
  const hasMessage = message && message.length > 0

  if (wait > 0 && hasUrl) {
    const className = classnames(
      'flash-notification',
      `flash-notification--${type}`,
      'flash-notification--redirector',
      'p'
    )
    return (
      <div className={className}>
        <div className="redirector__spinner">
          <Spin />
        </div>
        {hasMessage && <div className="redirector__text">{message}</div>}
      </div>
    )
  }
  return null
}

Redirector.defaultProps = {
  type: 'notice',
  message: null,
  url: null,
  wait: 0,
}
Redirector.propTypes = {
  url: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'notice', 'alert']),
  wait: PropTypes.number.isRequired,
}

export default Redirector
